import React from 'react'
import withIcon from '@/components/withIcon'

const IconDiamond = ({ className }) => {
  return (
    <svg
      className={className}
      width="85"
      height="63"
      viewBox="0 0 85 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_23728_41734)">
        <path
          d="M3 33.5H45"
          stroke="#162941"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M24 60.5L32 33.5L24 20.5"
          stroke="#162941"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M24 20.5L16 33.5L24 60.5"
          stroke="#162941"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M11 20.5L16 33.5"
          stroke="#162941"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M37 20.5L32 33.5"
          stroke="#162941"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M45 33.5L24 60.5L3 33.5L11 20.5H37L45 33.5Z"
          stroke="#162941"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M47.7374 14.0506C48.4599 13.2856 49.0519 12.4117 49.5 11.4665C49.9481 12.4117 50.5401 13.2856 51.2626 14.0506C52.0234 14.8561 52.9026 15.5126 53.8586 16C52.9026 16.4874 52.0234 17.1439 51.2626 17.9494C50.5401 18.7144 49.9481 19.5883 49.5 20.5335C49.0519 19.5883 48.4599 18.7144 47.7374 17.9494C46.9766 17.1439 46.0974 16.4874 45.1414 16C46.0974 15.5126 46.9766 14.8561 47.7374 14.0506ZM58 15V17C56.0299 17 54.1281 17.8281 52.7166 19.3227C51.3033 20.8191 50.5 22.8604 50.5 25H48.5C48.5 22.8604 47.6967 20.8191 46.2834 19.3227C44.8719 17.8281 42.9701 17 41 17V15C42.9701 15 44.8719 14.1719 46.2834 12.6773C47.6967 11.1809 48.5 9.13959 48.5 7H50.5C50.5 9.13959 51.3033 11.1809 52.7166 12.6773C54.1281 14.1719 56.0299 15 58 15Z"
          fill="#162941"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.682 6.0028C28.2056 5.43982 28.6473 4.8082 29 4.12866C29.3527 4.8082 29.7944 5.43982 30.318 6.0028C30.8872 6.61474 31.5359 7.12668 32.2397 7.52599C31.5359 7.9253 30.8872 8.43723 30.318 9.04917C29.7944 9.61216 29.3527 10.2438 29 10.9233C28.6473 10.2438 28.2056 9.61216 27.682 9.04917C27.1128 8.43723 26.4641 7.9253 25.7603 7.52599C26.4641 7.12668 27.1128 6.61474 27.682 6.0028ZM22 8.52588V6.5261V6.52588C22.0124 6.52588 22.0248 6.52591 22.0372 6.52597C23.591 6.51547 25.0947 5.84786 26.2175 4.6407C27.3515 3.42146 28 1.75327 28 0H30C30 1.75327 30.6485 3.42146 31.7825 4.6407C32.9053 5.84787 34.409 6.51548 35.9628 6.52597C35.9752 6.52591 35.9876 6.52588 36 6.52588V6.5261V8.52588V8.5261C35.9876 8.5261 35.9752 8.52607 35.9628 8.526C34.409 8.5365 32.9053 9.2041 31.7825 10.4113C30.6485 11.6305 30 13.2987 30 15.052H28C28 13.2987 27.3515 11.6305 26.2175 10.4113C25.0947 9.2041 23.591 8.5365 22.0372 8.526C22.0248 8.52607 22.0124 8.5261 22 8.5261V8.52588Z"
          fill="#162941"
        />
      </g>
      <defs>
        <clipPath id="clip0_23728_41734">
          <rect
            width="85"
            height="62"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default withIcon(IconDiamond)
